/**
 * Copilot grid layout.
 *
 * The copilot TX view (TXLive.jsx) lays out its blocks in a react-grid-layout
 * grid. There is a single fixed arrangement ("balanced") — the layout is not
 * operator-configurable (the picker + custom/free-arrange mode were removed).
 *
 * Block keys MUST match the grid item keys in TXLive.jsx:
 *   clock | homeLineup | awayLineup | rightCol
 *
 * The `h` values are intentionally fractional (e.g. 8.4) to match the existing
 * grid convention — react-grid-layout multiplies them by rowHeight.
 */

// Each column totals h=9.4 so the left and right columns line up at the bottom.
export const COPILOT_LAYOUT_PRESETS = {
  // Left ~40% column: the score/clock header sits ON TOP of the two team
  // lineups (which together span that 40% — homeLineup + awayLineup below it).
  // The 40% gives the score header room so the goal +/- buttons aren't clipped.
  // Right ~60% column ("rightCol") runs the FULL height from the very top, so
  // the tabs sit at the top of the app and stats fills the rest below (see
  // rightColumnElement in TXLive).
  balanced: [
    { i: "clock",      x: 0,  y: 0,   w: 10, h: 1.0 },
    { i: "homeLineup", x: 0,  y: 1.0, w: 5,  h: 8.4 },
    { i: "awayLineup", x: 5,  y: 1.0, w: 5,  h: 8.4 },
    { i: "rightCol",   x: 10, y: 0,   w: 14, h: 9.4 },
  ],
};
